import script from "./OtpGenerate.vue?vue&type=script&lang=ts&setup=true"
export * from "./OtpGenerate.vue?vue&type=script&lang=ts&setup=true"

import "./OtpGenerate.vue?vue&type=style&index=0&id=5c3fc2dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3fc2dc"]])

export default __exports__